import { useState, useEffect } from "react";
import { wrapperRequests } from "../../../services/api";
import { routesURL } from "../../../services/routesUrl";
import { Tag } from "../../../@types/Tags";

export default function useTags() {
  const [tags, setTags] = useState<Tag[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchTags = async () => {
    setLoading(true);

    try {
      const response = await wrapperRequests(
        routesURL.inventory.tags.getAllTags,
        "GET",
      );

      setTags(response.data);
    } catch (err) {
      console.error("Error loading tags:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  return {
    tags,
    loading,
    refetch: fetchTags,
  };
}
